"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavDrawerCtrl = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var page_registry_1 = require("../../page/page.registry");
var services_1 = require("../../services");
var NavDrawerCtrl = /** @class */ (function () {
    function NavDrawerCtrl() {
        this.visible = false;
    }
    Object.defineProperty(NavDrawerCtrl.prototype, "entries", {
        get: function () {
            var entries = [];
            for (var _i = 0, _a = page_registry_1.PageRegistry.pages; _i < _a.length; _i++) {
                var config = _a[_i].config;
                if (config.nav == null) {
                    continue;
                }
                var currentUser = services_1.Services.User.current;
                var userProfile = currentUser ? services_1.Services.UserProfile.get(currentUser.objectId) : null;
                if ((config.auth.tokens == null || services_1.Services.Token.hasAll(config.auth.tokens))
                    && (config.auth.userLevel == null || services_1.Services.UserProfile.isOneOf(userProfile, config.auth.userLevel))) {
                    entries.push({
                        type: config.type,
                        title: config.nav.name,
                        icon: config.nav.icon,
                        name: config.name,
                        current: services_1.Services.Route.active.config.name === config.name
                    });
                }
            }
            return entries;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavDrawerCtrl.prototype, "username", {
        get: function () {
            var user = services_1.Services.User.current;
            if (user != null) {
                return services_1.Services.User.current.username;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    NavDrawerCtrl.prototype.setVisible = function (visible) {
        this.visible = visible;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], NavDrawerCtrl.prototype, "visible", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], NavDrawerCtrl.prototype, "entries", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], NavDrawerCtrl.prototype, "username", null);
    tslib_1.__decorate([
        mobx_1.action
    ], NavDrawerCtrl.prototype, "setVisible", null);
    return NavDrawerCtrl;
}());
exports.NavDrawerCtrl = NavDrawerCtrl;
//# sourceMappingURL=nav.drawer.ctrl.js.map